import * as React from 'react';
import Box from '@mui/material/Box';
import { GridRenderCellParams, GridRowId } from '@mui/x-data-grid';
import { Button, Hidden } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface CTAValueProps {
  name: string;
  href: string;
  value: string;
  windowTarget?: string;
}

const CTAValue = ({ value, href, windowTarget = '_blank' }: CTAValueProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Hidden mdUp>
        <ArrowForwardIosIcon
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            window.open(href, windowTarget);
          }}
        />
      </Hidden>
      <Hidden mdDown>
        <Button
          size={'small'}
          variant="contained"
          href={href}
          target={windowTarget}
        >
          {value}
        </Button>
      </Hidden>
    </Box>
  );
};

const MemoizedCTAValue = React.memo(CTAValue);

export function renderCTA(
  params: GridRenderCellParams<any, { id: GridRowId }, any>
) {
  if (params.rowNode.isAutoGenerated || params.value == null) {
    return '';
  }
  return (
    <MemoizedCTAValue
      value={params.value.title}
      href={params.value.href}
      name={params.row.id.toString()}
      windowTarget={params.value.windowTarget}
    />
  );
}
